function LoadingSpinner({ message = 'Loading…' }) {
  return (
    <div className="loading-spinner-wrap" role="status" aria-live="polite">
      <div className="loading-spinner" aria-hidden="true" />
      {message && <p className="loading-spinner-message">{message}</p>}
    </div>
  )
}

export default LoadingSpinner
